// src/plugins/auth.js
import axios from "axios";
import Cookies from "js-cookie";


const TOKEN_KEY = "auth_token";

export function getToken() {
  return Cookies.get(TOKEN_KEY);
}

export function setToken(token) {
  Cookies.set(TOKEN_KEY, token, { expires: 1 });
}

export function clearToken() {
  Cookies.remove(TOKEN_KEY);
}

/**
 * เช็ค token ที่อยู่ใน cookie ว่ายังใช้ได้อยู่ไหม
 * ผ่าน GET /api/auth/me
 * @returns {boolean}
 */
export async function checkAuth(baseUrl) {
  const token = getToken();
  if (!token) return false;

  try {
    const res = await axios.get(`${baseUrl}/api/auth/me`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data.success === true;
  } catch {
    clearToken();
    return false;
  }
}